/**
 * App Insights config.
 *
 * See: https://learn.microsoft.com/en-us/azure/azure-monitor/app/javascript-sdk-configuration
 */

import type { Snippet } from '@microsoft/applicationinsights-web';
import { env } from '@/env';

export const config: Snippet['config'] = {
  connectionString: env.appInsights.connectionString,
  // Delay for accumulating events before send: prod: 3s, non-prod: 1s.
  // In e2e tests: 1ms (see instrumentation-client.ts).
  maxBatchInterval: env.isProduction ? 3000 : 1000,
  // track pageView events ourselves
  enableAutoRouteTracking: false,
  // track exceptions automatically
  disableExceptionTracking: false,
  enableUnhandledPromiseRejectionTracking: true,
  // Auto-instrumentation of fetch/xhr is enabled by default, keep for reference.
  // disableAjaxTracking: true,
  // disableFetchTracking: true,
};
